import React, { PureComponent } from 'react'
import { Modal, Tab, Tabs, Form, Col, Button, Row, Tooltip } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import VehiclesListModal from '../../../../components/dossiers/common/uac/VehiclesListModal'
import InputText from '../../../../components/commons/form/InputText'
import InputMoney from '../../../../components/commons/form/InputMoney'
import InputNatural from '../../../../components/commons/form/InputNatural'
import InputDatePicker from '../../../../components/commons/form/InputDatePicker'
import InputCheckBox from '../../../../components/commons/form/InputCheckBox'
import InputSelect from '../../../../components/commons/form/InputSelect'
import { entityTypesId, permissions, clientInformation, validationTypes } from '../../../../constants/backendIds'
import { validateDate, validateEntity, validateVinChassis, validateLicensePlate as validateLicensePlateFunciton } from '../../../../util/validationFunctions'
import { multipleNormalize, toUpperCase, trimAll } from '../../../../util/normalizeFunctions'
import settings from '../../../../setting'
import { getFieldsPermisions } from '../../../../util/permisionFunctions'
import UACAppraisalWithTAXModal from '../../../../components/dossiers/common/uac/UACAppraisalWithTAXModal'
import { previousUsagesCode } from '../../../../constants/dossier/purchase/previousUsages'
import { purchaseTypesVo } from '../../../../constants/dossier/purchase/purchaseTypes'
import InputNumber from '../../../../components/commons/form/InputNumber'
import { modelLength } from '../../../../constants/dossier/common/vehicle'
import commonRegExp from '../../../../util/commonRegExp'
import {
  asyncValidateEntityDni, getFieldsValidated
} from '../../../../util/validationFunctionEntityDniAsync'
import { validationUACModalPromisesOrder } from '../../../../constants/validatedFields/backValidationPromisesOrder'
import promisesStatus from '../../../../constants/promisesStatus'
import { dossierTypes as dossierTypesConstant } from '../../../../constants/dossier/common/dossierTypes'
import ClientData from '../../../../components/dossiers/common/clientData/ClientData'
import { handleKeyDown } from '../../../../util/utils'

class UACModal extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      entityFromParentDossier: true,
      showVehiclesListModal: false,
      vehiclesList: [],
      entityTypeId: null,
      changedBeforeSelectVehicle: false,
      showModalwithTAX: false,
      valueIva: null,
      allInformationDisabled: true,
      entityComponent: null,
      entitySubtypeId: null,
      dniDisabled: true,
      disabledValidateLicensePlate: false,
      showPurchaseContract: false,
      fieldsConfiguration: {
        uacDealerNumber: {
          permission: null
        },
        stockStatusId: {
          permission: null
        },
        expirationItvDate: {
          permission: null
        },
        checkNotContractPurchaseVehicle: {
          permission: null
        },
        rescueLeasing: {
          permission: null
        },
        additionalInvoice: {
          permission: null
        },
        entityFromParentDossier: null,
        entityTypeId: null,
        entitySubTypeId: null,
        entityId: null,
        dniCif: null,
        clientNumber: null,
        name: null,
        surname1: null,
        surname2: null,
        representativeDni: null,
        representativeName: null,
        representativeSurname1: null,
        representativeSurname2: null,
        address: null,
        city: null,
        state: null,
        cp: null,
        country: null,
        phone: null,
        mobilePhone: null,
        email: null,
        sourceChannelId: null,
        segmentationId: null,
        parentEntityId: null,
        iaeTypeId: null,
        dniCifValidationDisable: null,
        representativeDniCifValidationDisable: null,
        rfc: null,
        brandReference: null,
        unitReferenceNumber: null,
        comercialCode: null,
        modelUacNumeric: null,
        modelUac: null,
        freeLance: null,
        maritalcmb: null,
        startStreet: null,
        enndStreet: null,
        internalNumber: null,
        externalNumber: null,
        countryCode: null,
        stateCode: null,
        townCode: null,
        cityCode: null,
        colonyCode: null,
        cpCode: null,
        commercialSocietyTypeId: null,
        activityBproId: null,
        birthdayDate: null,
        constitutionAct: null,
        constitutionDate: null
      },
      rfcNoEditable: true,
      additionalInvoice: false,
      rescueLeasing: false,
      additionalInvoiceDisabled: true,
      freeLance: false
    }
    this.validateLicensePlate = this.validateLicensePlate.bind(this)
    this.validationDate = this.validationDate.bind(this)
    this.handleDNI = this.handleDNI.bind(this)
    this.getEntityRfc = this.getEntityRfc.bind(this)
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  UNSAFE_componentWillMount () {
    this.setState({ permission: 0 })
  }

  componentDidMount () {
    this.setState({ allMaritalStatus: this.props.dossier?.entityComponent?.maritalStatusId !== null })
  }

  resetVehicleOnFilterChange () {
    this.setState({ changedBeforeSelectVehicle: true })
    this.props.change('uacVehicleComplete.vehicleId', null)
  }

  toggleVehiclesListModal (showVehiclesListModal, vehiclesList = []) {
    this.setState({ showVehiclesListModal, vehiclesList })
  }

  setEntityFromParentDossier (entityFromParentDossier) {
    entityFromParentDossier && this.props.change('entityComponent', null)
    this.setState({
      entityFromParentDossier,
      entityComponent: {},
      entityTypeId: null,
      entityId: null,
      entitySubTypeId: null,
      allInformationDisabled: true,
      dniCifValidationDisable: null,
      representativeDniCifValidationDisable: null,
      dniCif: null,
      dniDisabled: true
    })
  }

  submitUAC (values) {
    var payPerDriveAlert = false
    const previousUsageId = this.props.uacModalForm.values.uacVehicleComplete.previousUsageId
    const previousUsageCode = previousUsageId ? this.props.combos.previousUsageCombo.find((value) => { return value.id === previousUsageId }).code : null
    if (settings.clientFieldValidation === 'toyo' && !(previousUsageCode && previousUsageCode === previousUsagesCode.payPerDrive)) {
      payPerDriveAlert = true
    }
    const subValues = { ...values, isPartOfPayment: !!values.isPartOfPayment, entityFromParentDossier: !!values.entityFromParentDossier, payPerDriveAlert: payPerDriveAlert, organizedUnitId: this.props.dossier.organizedUnitId }
    if (values.purchaseId) {
      this.props.actions.updateUAC(subValues, this.props.actions.closeModal, this.toggleVehiclesListModal.bind(this), this.props.dossierType)
    } else {
      this.props.actions.createUAC(subValues, this.props.actions.closeModal, this.toggleVehiclesListModal.bind(this), !this.state.changedBeforeSelectVehicle ? values.uacVehicleComplete.vehicleId : null, this.props.dossierType)
    }
    this.setState({ changedBeforeSelectVehicle: false })
  }

  getEntityPromise (value) {
    return new Promise((resolve, reject) => {
      return this.props.actions.fetchClientByDni(value, this.props.organizedUnitId, null, resolve, reject)
    })
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    const newState = {}
    if (nextProps.showModal && !this.props.showModal) {
      if (Object.keys(nextProps.uacUnit).length === 0) {
        nextProps.initialize({ entityFromParentDossier: true, isPartOfPayment: true, moveToVOCompany: true })
      } else {
        if (nextProps.uacUnit && !nextProps.uacUnit.entityFromParentDossier) {
          newState.entityFromParentDossier = false
        }
        if (nextProps.uacUnit.uacEntityOwner && this.state.entityTypeId !== nextProps.uacUnit.uacEntityOwner.entityTypeId) {
          newState.entityTypeId = (nextProps.uacUnit.uacEntityOwner && nextProps.uacUnit.uacEntityOwner.entityTypeId) ? nextProps.uacUnit.uacEntityOwner.entityTypeId : null
        }
        this.setState(newState)
      }
    } else if (!nextProps.showModal && this.props.showModal) {
      nextProps.initialize({})
      this.setState({
        entityFromParentDossier: true,
        entityComponent: {},
        entityTypeId: null,
        entityId: null,
        entitySubTypeId: null,
        allInformationDisabled: true,
        dniCifValidationDisable: null,
        representativeDniCifValidationDisable: null,
        dniCif: null,
        dniDisabled: true,
        showPurchaseContract: false
      })
    }
    if (this.props.submitFailed === false && nextProps.submitFailed === true) {
      this.showValidationAlert(nextProps)
    }

    if (nextProps.componentConfiguration && JSON.parse(JSON.stringify(this.props.componentConfiguration)) !== JSON.parse(JSON.stringify(nextProps.componentConfiguration))) {
      this.initializePermisions(nextProps)
    }
  }

  showValidationAlert (props) {
    if (props.submitFailed && props.uacModalForm.syncErrors) {
      if (!props.uacModalForm.syncErrors.entityComponent || (props.uacModalForm.syncErrors.entityComponent && Object.keys(props.uacModalForm.syncErrors.entityComponent).length > 0)) {
        this.props.actions.openCommonModal('mustFillUac')
      }
    }
  }

  openOrCloseModalwithTAX (value) {
    this.setState({ showModalwithTAX: value })
  }

  setAmoutWithoutTax (value) {
    this.props.change('amount', value)
  }

  setTest (value) {
    this.props.change('UACamountWithoutTax', value)
  }

  validationDate (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  validateLicensePlate (value) {
    return validateLicensePlateFunciton(value, this.props.formValues && this.props.formValues.vehicleComponent.validateLicensePlateCountry || false, this.props.t('GLOBAL.FORMS.INVALID_STRING'))
  }

  getEntityNameLabel () {
    const tKey = 'DOSSIER_COMPONENTS.ENTITY.'
    switch (this.state.entityTypeId) {
      case entityTypesId.privateEntity:
        return this.props.t(`${tKey}NAME`)
      default:
        return this.props.t(`${tKey}REGISTERED_NAME`)
    }
  }

  handleDNI (dnicif, entityTypeId, disableValidation, representativeValidation = false, freeLance = false) {
    if (disableValidation) {
      if (!representativeValidation) {
        this.setState({ allInformationDisabled: dnicif === '' })
      }
    } else {
      if (representativeValidation) {
        this.setState({ representativeDni: dnicif })
      } else {
        let callbackFunction = dnicif === '' ? () => this.props.actions.clearClientFields(entityTypeId, this.props.dossierType) : () => true
        this.setState({ allInformationDisabled: true, dniCif: dnicif }, callbackFunction)
        new Promise((resolve, reject) => {
          if (entityTypeId === entityTypesId.privateEntity) {
            if (freeLance) {
              return this.props.actions.validate(validationTypes.FREELANCE_IDENTIFIER, { DniCif: dnicif }, this.props.dossier.organizedUnitId, resolve, reject, true)
            } else {
              return this.props.actions.validate(validationTypes.INDIVIDUAL_IDENTIFIER, { Dni: dnicif }, this.props.dossier.organizedUnitId, resolve, reject, true)
            }
          } else {
            return this.props.actions.validate(validationTypes.COMPANY_IDENTIFIER, { Cif: dnicif }, this.props.dossier.organizedUnitId, resolve, reject, true)
          }
        }).then(() => {
          this.setState({ allInformationDisabled: dnicif === '', dniCif: dnicif })
        }).catch(() => {})
      }
    }
  }

  setValidationDisable (dniCifValidationDisable, representativeDniCifValidationDisable, freeLance) {
    this.setState({ uacEntityOwner: { ...this.state.uacEntityOwner, representativeDniCifValidationDisable: !!representativeDniCifValidationDisable, dniCifValidationDisable: !!dniCifValidationDisable } })

    if (dniCifValidationDisable !== null && dniCifValidationDisable !== undefined) {
      this.handleDNI(this.state.dniCif, this.state.entityTypeId, dniCifValidationDisable, false, freeLance)
    }
    if (representativeDniCifValidationDisable !== null && representativeDniCifValidationDisable !== undefined) {
      this.handleDNI(this.state.representativeDni, this.state.entityTypeId, representativeDniCifValidationDisable, true, freeLance)
    }
  }

  onRecurrentTypeIdChanges (entitySubTypeId) {
    this.setState({ entitySubTypeId })
    if (entitySubTypeId) {
      this.props.actions.fetchEntityFilterSubTypeCombo(this.state.entityTypeId, entitySubTypeId, this.props.dossier.organizedUnitId)
    }
  }

  onRecurrentEntityIdChanges (entityId) {
    if (entityId) {
      this.props.actions.fetchClientUacModal(entityId)
    }
  }

  changeBoolLicensePlate (value) {
    this.setState({ disabledValidateLicensePlate: value })
  }

  changeBoolRescueLeasing (value) {
    this.setState({ rescueLeasing: value, additionalInvoiceDisabled: !value })
    if (value === false) {
      this.setState({ additionalInvoice: false })
      this.props.change('additionalInvoice', false)
    }
  }

  changeBoolAdditionalInvoice (value) {
    this.setState({ additionalInvoice: value })
  }

  checkPurchaseType (value) {
    if (value === purchaseTypesVo.scrapping) {
      this.setState({ showPurchaseContract: true })
    } else {
      this.setState({ showPurchaseContract: false })
    }
  }

  getEntityRfc (value) {
    const rfc = value
    if (value) {
      new Promise((resolve, reject) => {
        return this.props.actions.checkPrivateRfcFormat(value, resolve)
      }).then((confirm) => {
        if (confirm) {
          this.props.actions.fetchClientByRfc(rfc, this.props.dossier.organizedUnitId, null)
        } else {
          this.props.change('uacEntityOwner.rfc', null)
        }
      })
    }
  }

  setFreelance (value) {
    this.setState({ freeLance: value })
    this.handleDNI(this.state.dniCif, this.state.entityTypeId, this.state.uacEntityOwner?.dniCifValidationDisable, false, value)
    asyncValidate({ uacEntityOwner: { dniCif: this.state.dniCif, dniCifValidationDisable: this.state.uacEntityOwner?.dniCifValidationDisable, entityTypeId: this.state.entityTypeId, freeLance: value } }, this.props.actions.dispatch, this.props, 'dniCif', true).then((result) => {
      this.props.actions.stopAsyncValidation({ ...result })
    })
  }

  updateComponentAfterDeleteAndRestart () {

  }

  render () {
    const {
      t, handleSubmit, showModal, entityComponent,
      actions: {
        closeModal,
        chooseUACSuggestion
      },
      combos: {
        purchaseTypeCombo, brandCombo, fuelCombo, previousUsageCombo, stockStatusCombo, uacIvaTpyes
      },
      dossierType
    } = this.props

    const tKey = 'DOSSIER_COMPONENTS.UAC.MODAL.'
    const editTooltip = (<Tooltip id="editTooltip">{t('DOSSIER_COMPONENTS.VEHICLE.TOOLTIP_VALIDATE_LICENSE_PLATE')}</Tooltip>)
    return (
      <Modal className="_nf uac-modal UACModal" show={showModal} onHide={() => closeModal()}>
        <VehiclesListModal
          t={t}
          showModal={this.state.showVehiclesListModal}
          vehicles={this.state.vehiclesList}
          actions={{
            closeModal: (userClose) => {
              this.toggleVehiclesListModal(false)
              if (userClose) {
                this.resetVehicleOnFilterChange()
              }
            },
            chooseUACSuggestion: (purchaseId, vehicle, closeSuggestionModalFunc) => chooseUACSuggestion(purchaseId, vehicle, closeSuggestionModalFunc, closeModal, dossierType)
          }}
        />
        <Form autoComplete="off" onSubmit={handleSubmit(this.submitUAC.bind(this))} onKeyDown={(e) => handleKeyDown(e) } noValidate>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs id="uac" defaultActiveKey={1}>
              <Tab tabClassName="uac-vehicle-tab" eventKey={1} title={t(`${tKey}VEHICLE.TITLE`)} >
                <Row className="btn-modal-wrapper">
                  <Col className='fieldsContainer checkTop'>
                    <Field
                      component={InputCheckBox}
                      colWidth={50} // 25, 33, 50, 75, 100 default=25
                      id="entityFromParentDossierUac"
                      name="entityFromParentDossier"
                      placeholder={t(`${tKey}UAC_CLIENT.CLIENT_IS_SAME`)}
                      onInputChange={value => this.setEntityFromParentDossier(value)}
                    />
                    <Field
                      component={InputCheckBox}
                      colWidth={50} // 25, 33, 50, 75, 100 default=25
                      id="isPartOfPaymentUac"
                      name="isPartOfPayment"
                      placeholder={t(`${tKey}VEHICLE.IS_PART_OF_PAYMENT`)}
                    />
                    <Field
                      component={InputCheckBox}
                      colWidth={50} // 25, 33, 50, 75, 100 default=25
                      customClass="disable-license-plate-checkbox"
                      id="disabledValidateLicensePlateUac"
                      name="uacVehicleComplete.disabledValidateLicensePlate"
                      placeholder={t(`${tKey}VEHICLE.DISABLED_VALIDATE_LICENSE_PLATE`)}
                      onChange= {(value) => (this.changeBoolLicensePlate(value))}
                      tooltip= {editTooltip}
                    />
                    { this.state.fieldsConfiguration.rescueLeasing.permission !== permissions.hidden && (
                      <Field
                        component={InputCheckBox}
                        colWidth={50} // 25, 33, 50, 75, 100 default=25
                        id="rescueLeasing"
                        name="rescueLeasing"
                        placeholder={t(`${tKey}UAC_CLIENT.RESCUE_LEASING`)}
                        onInputChange={value => this.changeBoolRescueLeasing(value)}
                      />
                    )}
                    {this.state.fieldsConfiguration.additionalInvoice.permission !== permissions.hidden && (
                      <Field
                        component={InputCheckBox}
                        colWidth={50} // 25, 33, 50, 75, 100 default=25
                        id="additionalInvoice"
                        name="additionalInvoice"
                        placeholder={t(`${tKey}UAC_CLIENT.ADDITIONAL_INVOICE`)}
                        onInputChange={value => this.changeBoolAdditionalInvoice(value)}
                        disabled = {this.state.additionalInvoiceDisabled}
                      />
                    )}
                    { this.state.fieldsConfiguration.checkNotContractPurchaseVehicle.permission !== permissions.hidden && this.state.showPurchaseContract && settings.clientFieldValidation === clientInformation.QUADIS && (
                      <Field
                        component={InputCheckBox}
                        colWidth={50} // 25, 33, 50, 75, 100 default=25
                        id="notContractPurchaseVehicleUac"
                        name="uacVehicleComplete.notContractPurchaseVehicle"
                        placeholder={t(`${tKey}NOT_CONTRACT_PURCHASE_VEHICLE`)}
                        disabled={this.state.fieldsConfiguration.checkNotContractPurchaseVehicle.permission !== permissions.editable}
                      />
                    )}
                  </Col>
                </Row>
                <Row style={{ zIndex: 7 }} className='fieldsContainer'>
                  <Field
                    component={InputSelect}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="purchaseTypeIdUac"
                    name="purchaseTypeId"
                    controlLabel={t(`${tKey}VEHICLE.PURCHASE_TYPE`)}
                    placeholder={t(`${tKey}VEHICLE.PURCHASE_TYPE`)}
                    options={purchaseTypeCombo}
                    valueKey="id"
                    labelKey="value"
                    onInputChange={(value) => this.checkPurchaseType(value)}
                  />
                  <Field
                    component={InputText}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="vinChassisUac"
                    name="uacVehicleComplete.vinChassis"
                    controlLabel={t(`${tKey}VEHICLE.VIN_CHASSIS`)}
                    placeholder={t(`${tKey}VEHICLE.VIN_CHASSIS`)}
                    minLength={17}
                    maxLength={17}
                    normalize={value => multipleNormalize(value, [toUpperCase, trimAll])}
                    onChange={(value) => this.resetVehicleOnFilterChange()}
                  />
                  <Field
                    component={InputText}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="licensePlateUac"
                    name="uacVehicleComplete.licensePlate"
                    controlLabel={t(`${tKey}VEHICLE.LICENCE_PLATE`)}
                    placeholder={t(`${tKey}VEHICLE.LICENCE_PLATE`)}
                    validate={this.state.disabledValidateLicensePlate === false || this.state.disabledValidateLicensePlate === null ? [this.validateLicensePlate] : null }
                    normalize={value => multipleNormalize(value, [toUpperCase, trimAll])}
                    onChange={(value) => this.resetVehicleOnFilterChange()}
                  />
                  <Field
                    component={InputDatePicker}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="licensePlateDateUac"
                    name="uacVehicleComplete.licensePlateDate"
                    controlLabel={t(`${tKey}VEHICLE.LICENSE_PLATE`)}
                    validate={[this.validationDate]}
                  />
                </Row>
                <Row style={{ zIndex: 6 }} className='fieldsContainer'>
                  <Field
                    component={InputSelect}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="brandUac"
                    name="uacVehicleComplete.brandId"
                    controlLabel={t(`${tKey}VEHICLE.BRAND`)}
                    placeholder={t(`${tKey}VEHICLE.BRAND`)}
                    options={brandCombo}
                    valueKey="id"
                    labelKey="value"
                  />
                  {this.state.fieldsConfiguration.brandReference && this.state.fieldsConfiguration.brandReference.permission !== permissions.hidden && (
                    <Field
                      component={InputText}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="brandReference"
                      name="uacVehicleComplete.brandReference"
                      controlLabel={t(`${tKey}VEHICLE.CARLINE`)}
                      placeholder={t(`${tKey}VEHICLE.CARLINE`)}
                    />)}
                  {this.state.fieldsConfiguration.unitReferenceNumber && this.state.fieldsConfiguration.unitReferenceNumber.permission !== permissions.hidden && (
                    <Field
                      component={InputText}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="unitReferenceNumber"
                      name="uacVehicleComplete.unitReferenceNumber"
                      controlLabel={t(`${tKey}VEHICLE.CATALOG`)}
                      placeholder={t(`${tKey}VEHICLE.CATALOG`)}
                    />)}
                  {this.state.fieldsConfiguration.modelUacNumeric && this.state.fieldsConfiguration.modelUacNumeric.permission !== permissions.hidden && (
                    <Field
                      component={InputNumber}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="modelUacNumeric"
                      name="uacVehicleComplete.modelYear"
                      controlLabel={t(`${tKey}VEHICLE.MODEL_YEAR`)}
                      placeholder={t(`${tKey}VEHICLE.MODEL_YEAR`)}
                      maxLength={modelLength.maxLength}
                    />)}
                </Row>
                <Row style={{ zIndex: 5 }} className='fieldsContainer'>
                  {this.state.fieldsConfiguration.modelUac && this.state.fieldsConfiguration.modelUac.permission !== permissions.hidden && (
                    <Field
                      component={InputText}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="modelUac"
                      name="uacVehicleComplete.model"
                      controlLabel={t(`${tKey}VEHICLE.MODEL`)}
                      placeholder={t(`${tKey}VEHICLE.MODEL`)}
                    />)}

                  <Field
                    component={InputText}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="colorUac"
                    name="uacVehicleComplete.color"
                    controlLabel={t(`${tKey}VEHICLE.COLOR`)}
                    placeholder={t(`${tKey}VEHICLE.COLOR`)}
                  />
                  <Field
                    component={InputText}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="tapestryUac"
                    name="uacVehicleComplete.tapestry"
                    controlLabel={t(`${tKey}VEHICLE.TAPESTRY`)}
                    placeholder={t(`${tKey}VEHICLE.TAPESTRY`)}
                  />
                  {this.state.fieldsConfiguration.comercialCode && this.state.fieldsConfiguration.comercialCode.permission !== permissions.hidden && (
                    <Field
                      component={InputText}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="comercialCode"
                      name="uacVehicleComplete.comercialCode"
                      controlLabel={t(`${tKey}VEHICLE.MODEL_VERSION`)}
                      placeholder={t(`${tKey}VEHICLE.MODEL_VERSION`)}
                    />)}
                  <Field
                    component={InputSelect}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="fuelIdUac"
                    name="uacVehicleComplete.fuelId"
                    controlLabel={t(`${tKey}VEHICLE.FUEL_ID`)}
                    placeholder={t(`${tKey}VEHICLE.FUEL_ID`)}
                    options={fuelCombo}
                    valueKey="id"
                    labelKey="value"
                  />
                </Row>
                <Row style={{ zIndex: 4 }} className='fieldsContainer'>
                  <Field
                    component={InputDatePicker}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="availabilityDateUac"
                    name="uacVehicleComplete.availabilityDate"
                    controlLabel={t(`${tKey}VEHICLE.AVAILABILITY_DATE`)}
                    validate={[this.validationDate]}
                  />
                  <Field
                    component={InputNatural}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="kmUac"
                    name="uacVehicleComplete.km"
                    controlLabel={t(`${tKey}VEHICLE.KM`)}
                    placeholder={t(`${tKey}VEHICLE.KM`)}
                    textAlign="left"
                  />
                  {this.state.fieldsConfiguration.uacDealerNumber.permission !== permissions.hidden && (
                    <Field
                      component={InputText}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="dealerNumberUac"
                      name="uacVehicleComplete.dealerNumber"
                      controlLabel={t(`${tKey}VEHICLE.DEALER_NUMBER`)}
                      placeholder={t(`${tKey}VEHICLE.DEALER_NUMBER`)}
                      maxLength={settings.dealerMaxLength}
                    />)}
                  <Field
                    component={InputMoney}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="amountUac"
                    name="amount"
                    controlLabel={t(`${tKey}VEHICLE.APPRAISAL_VALUE`)}
                    placeholder={t(`${tKey}VEHICLE.APPRAISAL_VALUE`)}
                  />
                </Row>
                <Row style={{ zIndex: 3 }} className='fieldsContainer'>
                  <Field
                    component={InputSelect}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    id="previousUsageIdUac"
                    name="uacVehicleComplete.previousUsageId"
                    controlLabel={t(`${tKey}VEHICLE.PREVIOUS_USAGE_ID`)}
                    placeholder={t(`${tKey}VEHICLE.PREVIOUS_USAGE_ID`)}
                    options={previousUsageCombo}
                    valueKey="id"
                    labelKey="value"
                  />
                  {
                  /*
                  <Field
                    id="factoryNumber"
                    name="uacVehicleComplete.factoryNumber"
                    colSm={3}
                    controlLabel={t(`${tKey}VEHICLE.FACTORY_NUMBER`)}
                    placeholder={t(`${tKey}VEHICLE.FACTORY_NUMBER`)}
                    component={InputText}
                  />
                  <Field
                    id="commissionNumber"
                    name="uacVehicleComplete.commissionNumber"
                    colSm={3}
                    controlLabel={t(`${tKey}VEHICLE.COMMISSION_NUMBER`)}
                    placeholder={t(`${tKey}VEHICLE.COMMISSION_NUMBER`)}
                    component={InputText}
                  />
                  */
                  }
                  {this.state.fieldsConfiguration.stockStatusId && this.state.fieldsConfiguration.stockStatusId.permission !== permissions.hidden && (
                    <Field
                      component={InputSelect}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="stockStatusIdUac"
                      name="stockStatusId"
                      controlLabel={t(`${tKey}VEHICLE.STOCK_STATUS`)}
                      placeholder={t(`${tKey}VEHICLE.STOCK_STATUS`)}
                      valueKey="id"
                      labelKey="value"
                      options={stockStatusCombo}
                    />)}
                  {this.state.fieldsConfiguration.expirationItvDate && this.state.fieldsConfiguration.expirationItvDate.permission !== permissions.hidden && settings.clientFieldValidation === clientInformation.VGR && (
                    <Field
                      component={InputDatePicker}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="expirationItvDateUac"
                      name="uacVehicleComplete.expirationItvDate"
                      controlLabel={t(`${tKey}EXPIRATION_ITV_DATE`)}
                      validate={[this.validationDate]}
                    />)}
                </Row>
                { this.state.fieldsConfiguration.expirationItvDate && this.state.fieldsConfiguration.expirationItvDate.permission !== permissions.hidden && settings.clientFieldValidation === clientInformation.VGR && (
                  <Row style={{ zIndex: 2 }} className='fieldsContainer'>
                    <Field
                      component={InputSelect}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      customClass="column-planteo-iem-iva"
                      id="ivaTypeIdUac"
                      name="ivaTypeId"
                      controlLabel='IVA'
                      options={uacIvaTpyes}
                      valueKey="id"
                      labelKey="value"
                      onInputChange={(valueIva) => this.setState({ valueIva })}
                    />
                    { this.state.valueIva &&
                      <div className="colWidth-33">
                        <div className='form-group'>
                          <Button
                            className="_Btn accent fullW"
                            onClick={() => this.openOrCloseModalwithTAX(true)}>
                            {t('DOSSIER_COMPONENTS.ECONOMIC_PLAN.ADD_AMOUNT_WITH_TAX')}
                          </Button>
                        </div>
                      </div>
                    }

                    <UACAppraisalWithTAXModal
                      t={t}
                      showModal={this.state.showModalwithTAX}
                      actions={{
                        closeModal: () => this.openOrCloseModalwithTAX(false),
                        setAmoutWithoutTax: (value) => this.setAmoutWithoutTax(value),
                        setTest: (value) => this.setTest(value),
                        change: (field, value) => this.props.change(field, value)
                      }}
                      ivaTypeCombo={uacIvaTpyes}
                      valueCombo={this.state.valueIva}
                    />
                  </Row>
                )}
              </Tab>
              {!this.state.entityFromParentDossier && (
                <Tab eventKey={2} title={t(`${tKey}UAC_CLIENT.TITLE`)} tabClassName="uac-user-tab">
                  <Row className='fieldsContainer clientData'>
                    <ClientData
                      actions={{
                        ...this.props.actions,

                        asyncValidate,
                        stopAsyncValidation: (value) => this.props.actions.stopAsyncValidation('uacModal', value)
                      }}
                      combos= {this.props.combos}
                      fieldsConfiguration={this.state.fieldsConfiguration}
                      dossier= {{ entityComponent, organizedUnitId: this.props.dossier.organizedUnitId }}
                      readOnlyFields={false}
                      t={t}
                      dossierType = {dossierTypesConstant.uacModal}
                      isRecurrentEntityType = {(entityComponent && entityComponent.entityTypeId ? entityComponent.entityTypeId === entityTypesId.recurrentEntity : false)}
                      entityChangeable= {entityComponent && entityComponent.entityTypeId}
                      formValues={this.props.uacModalForm?.values}
                    />
                  </Row>
                </Tab>
              )}
            </Tabs>
          </Modal.Body>
          <Modal.Footer>
            <div className="flexInLine al-C">
              <Button id="btn_save_uac" className="_Btn accept" type="submit" onClick={() => this.showValidationAlert(this.props)}>{t(`${tKey}SAVE_BTN`)}</Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}
function validateUacModal (values, props) {
  const errors = {}
  const tKey = 'DOSSIER_COMPONENTS.UAC.MODAL.VALIDATION.'
  if (!values.entityFromParentDossier && (!values.entityComponent || !values.entityComponent.entityTypeId)) {
    errors.entityComponent = { entityTypeId: props.t(`${tKey}FILL_ENTITY`) }
  }
  if (values.entityComponent && values.entityComponent.entityTypeId) {
    errors.entityComponent = validateEntity(values.entityComponent, props)
  }
  if (!values.uacVehicleComplete || (!values.uacVehicleComplete.vinChassis && !values.uacVehicleComplete.licensePlate)) {
    errors.uacVehicleComplete = { vinChassis: props.t(`${tKey}FILL_VEHICLE`), licensePlate: props.t(`${tKey}FILL_VEHICLE`) }
  }
  if (values.uacVehicleComplete && values.uacVehicleComplete.vinChassis) {
    let validationVinChassis = validateVinChassis(values.uacVehicleComplete.vinChassis, props)
    if (!(Object.keys(validationVinChassis).length === 0 && validationVinChassis.constructor === Object)) {
      errors.uacVehicleComplete = { vinChassis: validationVinChassis }
    }
  }
  if (!values.purchaseTypeId) {
    errors.purchaseTypeId = props.t(`${tKey}FILL_PURCHASE_TYPE`)
  }
  if (settings.clientFieldValidation === 'vgr' && !values.amount) {
    errors.amount = props.t(`${tKey}FILL_AMOUNT`)
  }
  if (settings.clientFieldValidation === 'vgr' && (!values.uacVehicleComplete || !values.uacVehicleComplete.expirationItvDate)) {
    errors.uacVehicleComplete = { expirationItvDate: props.t('DOSSIER_COMPONENTS.UAC.MODAL.VALIDATION.FILL_ITV_EXP_DATE') }
  }

  if (settings.clientFieldValidation === clientInformation.BUSS) {
    if (!values.uacVehicleComplete || !values.uacVehicleComplete.brandId) {
      errors.uacVehicleComplete = { ...errors.uacVehicleComplete, brandId: props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_BRAND_MANDATORY') }
    }
    if (!values.uacVehicleComplete || !values.uacVehicleComplete.brandReference) {
      errors.uacVehicleComplete = { ...errors.uacVehicleComplete, brandReference: props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD') }
    }
    if (!values.uacVehicleComplete || !values.uacVehicleComplete.unitReferenceNumber) {
      errors.uacVehicleComplete = { ...errors.uacVehicleComplete, unitReferenceNumber: props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD') }
    }
    if (!values.uacVehicleComplete || !values.uacVehicleComplete.model) {
      errors.uacVehicleComplete = { ...errors.uacVehicleComplete, model: props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD') }
    }
    if (!values.uacVehicleComplete || !values.uacVehicleComplete.color) {
      errors.uacVehicleComplete = { ...errors.uacVehicleComplete, color: props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD') }
    }
    if (!values.uacVehicleComplete ||
      !values.uacVehicleComplete.modelYear ||
      !values.uacVehicleComplete.modelYear.match(commonRegExp.is4DigitYear)) {
      var errorMessage = values.uacVehicleComplete?.modelYear?.length > 0 &&
        !values.uacVehicleComplete.modelYear.match(commonRegExp.is4DigitYear)
        ? props.t('GLOBAL.FORMS.INVALID_STRING')
        : props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_MODEL_YEAR_MANDATORY')

      errors.uacVehicleComplete = { ...errors.uacVehicleComplete, modelYear: errorMessage }
    }
  }

  return errors
}

const asyncValidate = (values, dispatch, props, field, returnError) => {
  let promises = []
  if (values.entityComponent) {
    promises = promises.concat(asyncValidateEntityDni(values.entityComponent, dispatch, props, props.dossier?.organizedUnitId))
  }

  return Promise.allSettled(promises).then(result => {
    let error = {}
    for (let index = 0; index < result.length; index++) {
      const element = result[index]
      if (element.status === promisesStatus.FULFILLED) {
        switch (index) {
          case validationUACModalPromisesOrder.UAC_ENTITY_OWNER:
            error = { ...error, entityComponent: element.value }
            break
          default:
            break
        }
      }
    }
    if (Object.keys(error).length > 0 && !returnError) throw Object.assign(new Error(), error)
    if (returnError) return error
  })
}

export default reduxForm({
  form: 'uacModal',
  validate: validateUacModal,
  asyncValidate,
  asyncBlurFields: [...getFieldsValidated('entityComponent')]
})(UACModal)
